import React from 'react';
import { ConnectedLocationAutocomplete } from './LocationAutocomplete';
import { EntryPoint } from '../../models';

export function LocationAutocompleteSource({ departureOrArrival, activeProduct }) {
    const regexSpecialCharacters = activeProduct === EntryPoint.HOTELS ? /[!·*"();:@=+$,/?%#[\]]/g : /[!&·*"();:@=+$,/?%#[\]]/g;
    return {
        render: ({ onClickItem, displayedWord='', isFixedWidth=false } = {}) => {
            const removeSpecialCharacters = (str) => str.replace(regexSpecialCharacters, '');
            return (
                <ConnectedLocationAutocomplete
                    key="location-autocomplete"
                    departureOrArrival={departureOrArrival}
                    displayedWord={removeSpecialCharacters(displayedWord)}
                    onClickItem={onClickItem}
                    isFixedWidth={isFixedWidth}
                />
            );
        },
    };
}
